import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN, TINY_MARGIN } from '../../theme';

const useStyles = (background, isExtendedCta) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: MIDDLE_MARGIN,
        paddingBottom: MIDDLE_MARGIN,
        [theme.breakpoints.up('sm')]: {
          paddingTop: LARGE_MARGIN,
          paddingBottom: LARGE_MARGIN,
          background:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
      },
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        maxWidth: 952,
        [theme.breakpoints.up('md')]: {
          justifyContent: isExtendedCta ? 'space-between' : 'center',
          flexDirection: 'row',
        },
      },
      ctaLink: {
        flexShrink: 0,
        [theme.breakpoints.up('md')]: {
          ...(isExtendedCta && { marginLeft: MIDDLE_MARGIN }),
        },
      },
      btn: {
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          width: 'unset',
        },
      },
      textBlock: {
        marginBottom: SMALL_MARGIN,
        [theme.breakpoints.up('md')]: {
          marginBottom: 0,
        },
      },
      title: {
        textAlign: 'center',
        '& + $description': {
          marginTop: SMALL_MARGIN,
        },
        [theme.breakpoints.up('md')]: {
          textAlign: 'left',
          '& + $description': {
            marginTop: TINY_MARGIN,
          },
        },
      },
      description: {
        textAlign: 'center',
        [theme.breakpoints.up('md')]: {
          textAlign: 'left',
        },
      },
    }),
  );

export default useStyles;
